module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/app_tablet-1145c707a87d659f16e7c6318ee64543.png";